// extracted by mini-css-extract-plugin
module.exports = {"select":"TreeSelect_select__2fOnL","dropDown":"TreeSelect_dropDown__2Nv4_","node":"TreeSelect_node__3QfMD","icon":"TreeSelect_icon__1nRFY","title":"TreeSelect_title__UlrON"};